import React from "react";
import { Link } from "react-router-dom";

const ContactInformation = () => {
  return (
    <div className="contact-area-2 space-top" id="contact-sec">
      <div className="container">
        <div className="title-area text-center">
          <span className="sub-title6 justify-content-center">
            <span className="shape left">
              <span className="dots"></span>
            </span>
            CONTACT US
            <span className="shape right">
              <span className="dots"></span>
            </span>
          </span>
          <h2 className="sec-title">Contact Information</h2>
        </div>

        <div className="row gy-4 justify-content-center">
          <div className="col-xl-4 col-lg-6">
            <div className="contact-feature">
              <div className="contact-feature-icon">
                <i className="fal fa-location-dot"></i>
              </div>

              <div className="media-body">
                <p className="contact-feature_label">Corporate Office</p>

                <Link to="" className="contact-feature_link">
                  Deira, Naif, Dubai-UAE.
                </Link>
              </div>
            </div>
          </div>

          <div className="col-xl-4 col-lg-6">
            <div className="contact-feature">
              <div className="contact-feature-icon">
                <i className="fal fa-envelope"></i>
              </div>

              <div className="media-body">
                <p className="contact-feature_label">Email</p>

                <Link
                  to="mailto:info@aljurfpestcontrol.ae"
                  className="contact-feature_link"
                >
                  info@aljurfpestcontrol.ae
                </Link>
              </div>
            </div>
          </div>

          <div className="col-xl-4 col-lg-6">
            <div className="contact-feature">
              <div className="contact-feature-icon">
                <i className="fal fa-phone"></i>
              </div>

              <div className="media-body">
                <p className="contact-feature_label">Call</p>

                <Link to="tel:056 118 4114" className="contact-feature_link">
                  Mobile : 056 118 4114
                </Link>
              </div>
            </div>
          </div>

          <div className="col-lg-12">
            <div className="contact-wrap2">
              <div className="contact-form-wrap">
                <h2 className="title h3 text-center mt-n1 mb-4">
                  Get In Touch
                </h2>

                <form className="contact-form ajax-contact">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control"
                          name="name"
                          id="name"
                          placeholder="Your Name*"
                        />
                        <i className="fal fa-user"></i>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <input
                          type="tel"
                          className="form-control"
                          name="number"
                          id="number"
                          placeholder="Phone Number*"
                        />
                        <i className="fal fa-phone"></i>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control"
                          name="subject"
                          id="subject"
                          placeholder="Subject*"
                        />
                        <i className="fal fa-edit"></i>{" "}
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="form-group">
                        <textarea
                          name="message"
                          id="message"
                          cols="30"
                          rows="3"
                          className="form-control"
                          placeholder="Write Your Message*"
                        ></textarea>
                        <i className="fal fa-pen"></i>
                      </div>
                    </div>

                    <div className="form-btn col-12">
                      <button className="th-btn w-100">
                        Send Message
                        <i className="fas fa-long-arrow-right ms-2"></i>
                      </button>
                    </div>
                  </div>
                  <p className="form-messages mb-0 mt-3"></p>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactInformation;
